
export const queryGiftCode = `
query GiftCodeInfo($giftCode: String!) {
    giftCodeInfo(giftCode: $giftCode) {
      giftCode
      giftPrice
      giftType
    }
  }
`
